
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tester_product",
      function () {
        return require("private-next-pages/tester_product.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tester_product"])
      });
    }
  